import { Auth, sendEmailVerification, sendSignInLinkToEmail, User, sendPasswordResetEmail } from "firebase/auth";

// See: https://firebase.google.com/docs/auth/web/email-link-auth

const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  url: "https://memories-dev-247.web.app/finishSignUp?returnUrl=",

  // This must be true.
  handleCodeInApp: true,
  iOS: {
    bundleId: "com.example.ios",
  },
  android: {
    packageName: "com.example.android",
    installApp: true,
    minimumVersion: "12",
  },
  // The domain must be configured in Firebase Hosting and owned by the project.
  linkDomain: "memories-dev-247.web.app",
};

export async function sendVerificationEmail(domain: string, user: User): Promise<void> {
  const settings = {
    ...actionCodeSettings,
    url: `http://${domain}/sign-in/?email=${user.email}`,
    linkDomain: domain,
  };

  await sendEmailVerification(user, settings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem("emailForSignIn", user.email!);
      // ...
      console.log("Sent email verification", user);
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorCode, errorMessage);
      //TODO: Raise error!?!
      throw error;
    });
}

export async function sendSignInEmail(domain: string, auth: Auth, email: string, returnUrl: string): Promise<void> {
  const settings = {
    ...actionCodeSettings,
    url: `http://${domain}/sign-in/?email=${email}`,
    linkDomain: domain,
  };

  await sendSignInLinkToEmail(auth, email!, settings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem("emailForSignIn", email);
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorCode, errorMessage);
      //TODO: Raise error!?!
      throw error;
    });
}

export async function sendPasswordReset(domain: string, auth: Auth, email: string): Promise<void> {
  const settings = {
    ...actionCodeSettings,
    url: `http://${domain}/sign-in/`,
    linkDomain: domain,
  };

  await sendPasswordResetEmail(auth, email, settings)
    .then(() => {
      console.log("Sent password reset email to", email);
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorCode, errorMessage);
      throw error;
    });
}
